import React, { useContext } from 'react'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'

export default function Timeline({ selectedScenario, campaignReport, values }) {
  const { campaign } = useContext(SharedCampaignContext)

  const actions = selectedScenario?.actions.filter((action) => action.action_type !== 'non_media_item' && action.visible_in_budget).sort((a, b) => new Date(a.start_date) - new Date(b.start_date))

  const TimelineItem = ({ action }) => {
    return (
      <div
        className="p-1 flex gap-2 items-center transform -rotate-45"
        style={{ transformOrigin: 'bottom left' }}
      >
        <img src={action.avatar} alt={action.auth_username} className='w-10 h-10 rounded-full' />
        <div className='flex flex-col gap-1'>
          <p className='text-sm font-bold whitespace-nowrap'>{action.name}</p>
          <div className='flex gap-1 justify-center items-center whitespace-nowrap'>
            <p className='text-xs'>{action.start_date}</p>
            <div className='w-1 h-1 bg-rb-black rounded-full' />
            <p className='text-xs'>{action.end_date}</p>
          </div>
        </div>
      </div>
    )
  }
    return (
      <div className='w-full bg-white border-1 border-rb-widget-border rounded-lg p-4'>
        { !values && <h1 className='font-bold text-xl py-2'>Timeline</h1>}
        <div className="w-full">
          <div className="w-full flex justify-between items-end pl-14 overflow-x-auto" style={{ minHeight: '160px' }}>
            {
              actions?.map((action) => (
                <TimelineItem key={action.id} action={action} />
              ))
            }
          </div>

          <div className="flex flex-1 items-center p-2 pt-0 mb-2">
            <div className='h-4 w-4 border-2 border-border-primary rounded-full bg-rb-grey' />
            <div className='border-t-4 border-rb-green w-full' />
            <div className='h-4 w-4 border-2 border-rb-green rounded-full bg-rb-soft-green' />
          </div>

          {
            !values && (
              <div className='flex justify-between items-center'>
                <p className='font-bold text-sm'>{campaignReport.start_date || campaign.start_date}</p>
                <p className='font-bold text-sm'>{campaignReport.end_date || campaign.end_date}</p>
              </div>
            )
           }
        </div>
      </div>
    )
}